import React from "react";
import { Text, View } from "native-base";
import { Minimize2, Move } from "lucide-react-native";
import { webFont } from "../../../Universal/API/API";
import PressableWrapp from "../../../Universal/Buttons/PressableReact/PressableWrapp";
import { webCursorPointer } from "./helpers";

type PanelHeaderProps = {
  scaleAll: number;
  onCollapse: () => void;
  panHandlers: object;
};

const PanelHeader: React.FC<PanelHeaderProps> = ({ scaleAll, onCollapse, panHandlers }) => {
  return (
    <View
      {...panHandlers}
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingHorizontal: 16 * scaleAll,
        paddingVertical: 12 * scaleAll,
        borderBottomWidth: 1,
        borderBottomColor: "#F0ECE5",
        backgroundColor: "#FBFAF8",
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", flex: 1, minWidth: 0 }}>
        <View
          style={{
            width: 34 * scaleAll,
            height: 34 * scaleAll,
            borderRadius: 12 * scaleAll,
            backgroundColor: "#F2EFE8",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 10 * scaleAll,
          }}
        >
          <Move size={16 * scaleAll} color="#5F5B55" />
        </View>

        <View style={{ flex: 1, minWidth: 0 }}>
          <Text
            selectable={false}
            numberOfLines={1}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 15 * scaleAll,
              color: "#111111",
              fontWeight: "700",
            }}
          >
            История заказов
          </Text>
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 11 * scaleAll,
              color: "#7A746C",
              fontWeight: "600",
              marginTop: 2 * scaleAll,
            }}
          >
            Перемещай окно по странице
          </Text>
        </View>
      </View>

      <PressableWrapp
        onPress={onCollapse}
        style={[
          {
            width: 34 * scaleAll,
            height: 34 * scaleAll,
            borderRadius: 12 * scaleAll,
            backgroundColor: "#111111",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: 10 * scaleAll,
          },
          webCursorPointer,
        ]}
      >
        <Minimize2 size={16 * scaleAll} color="#FFFFFF" />
      </PressableWrapp>
    </View>
  );
};

export default React.memo(PanelHeader);
